import { Radio, RadioChangeEvent, Space, Tooltip } from "antd";
import { RadioButton } from "ui";
import { COUNT_BADGE_TYPE } from "interfaces";
import styles from "./filters.module.css";

interface FilterOption<T = string> {
  value: T;
  label: string;
  tooltip?: string;
  count?: number;
  disabled?: boolean;
  hidden?: boolean;
}

interface FilterTabsProps<T = string> {
  options: FilterOption<T>[];
  currentValue?: T;
  onChange: (value: T) => void;
  allOptionTooltip?: string;
  allOptionLabel?: string;
  allOptionCount?: number;
  className?: string;
  formatCount?: (count: number) => string | number;
  radioGroupProps?: Record<string, any>;
}

const defaultFormatCount = (count: number) => (count > 99 ? "99+" : count);

export const FilterTabs = <T extends string | undefined = string>({
  options,
  currentValue,
  onChange,
  allOptionTooltip = "Список всех заявок, требующих от вас выполнения определенных действий",
  allOptionLabel = "Все",
  className,
  formatCount = defaultFormatCount,
  radioGroupProps,
  allOptionCount,
}: FilterTabsProps<T>) => {
  const handleStatusClick = (e: RadioChangeEvent) => {
    onChange(e.target.value);
  };

  const filteredOptions = options.filter((option) => !option.hidden);

  return (
    <Space className={className}>
      <Radio.Group
        name="type"
        optionType="button"
        buttonStyle="solid"
        className="radio-group"
        onChange={handleStatusClick}
        value={currentValue}
        {...radioGroupProps}
      >
        <Tooltip title={allOptionTooltip} color="white" overlayInnerStyle={{ color: "black" }}>
          <RadioButton
            value={undefined}
            className={styles.radioButton}
            count={allOptionCount !== undefined ? formatCount(allOptionCount) : undefined}
            countBadgeProps={{ color: "primary", countBadge: COUNT_BADGE_TYPE.BADGE }}
          >
            {allOptionLabel}
          </RadioButton>
        </Tooltip>

        {filteredOptions.map((option) => (
          <Tooltip
            color="white"
            overlayInnerStyle={{ color: "black" }}
            key={String(option.value)}
            title={option.tooltip}
          >
            <RadioButton
              value={option.value}
              disabled={option.disabled}
              count={option.count !== undefined ? formatCount(option.count) : undefined}
              className={styles.radioButton}
              countBadgeProps={{ color: "primary", countBadge: COUNT_BADGE_TYPE.BADGE }}
            >
              {option.label}
            </RadioButton>
          </Tooltip>
        ))}
      </Radio.Group>
    </Space>
  );
};
